import { SideModal } from "shared";
import { CompanyMyType } from "types/CompanyTypes";
import "./TransactionsSideModal.scss";
import TransactionsTable from "./components/TransactionsTable";
import { useGetMe } from "hooks/auth";
import { SharesByCompanyType } from "types/SharesTypes";

interface TransactionsSideModalProps {
  isOpen: boolean;
  onClose: () => void;
  company: CompanyMyType | null;
  setEditTransaction: (company: SharesByCompanyType) => void;
}

const TransactionsSideModal: React.FC<TransactionsSideModalProps> = ({
  isOpen,
  onClose,
  company,
  setEditTransaction,
}) => {
  const client =
    company && company.shares && company.shares[0] && company?.shares[0]?.user;
  const { data: authorizedUser } = useGetMe();
  const isAdmin = authorizedUser?.role === "admin";
  return (
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Lista transakcji"
      subtitle={
        isAdmin ? (
          <p>
            <b>Spółka:</b> {company?.name || "-"} | <b>Klient:</b>{" "}
            {client?.name || "-"}
          </p>
        ) : (
          <p>
            <b>Spółka:</b> {company?.name || "-"}{" "}
          </p>
        )
      }
      className="company-info-modal wide"
    >
      <>
        <TransactionsTable
          company={company}
          setEditTransaction={setEditTransaction}
        />
      </>
    </SideModal>
  );
};

export default TransactionsSideModal;
